import { defaultVesperColors } from "redmond";

export const colors = defaultVesperColors;
